import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ThresholdCard from "./ThresholdCard";
import { getPatientVitalThreshold } from "../../../../../redux/reducers/patientVitalThresholdReducer"; // Update with your correct import

const Threshold = React.memo(function Threshold({ patient = {} }) {
    const dispatch = useDispatch();
    const { currentPatientVitalsThresholds = [], loading = false } = useSelector((state) => state?.patientVitalThreshold);

    useEffect(() => {
        if (patient?.patientId) {
            dispatch(getPatientVitalThreshold({ patientId: patient.patientId }));
        }
    }, [dispatch, patient?.patientId]);

    // Parse and map threshold data
    const thresholdsMap = useMemo(() => {
        const map = {};
        currentPatientVitalsThresholds?.forEach((item) => {
            let parsedData = JSON.parse(item.data || "{}");
    
            if (parsedData.systolic || parsedData.diastolic) {
                for (const key of ['systolic', 'diastolic']) {
                    try {
                        if (typeof parsedData[key] === 'string') {
                            parsedData[key] = JSON.parse(parsedData[key]);
                        }
                    } catch (e) {
                        console.error(`Failed to parse ${key}`, e);
                    }
                }
    
                const thresholds = ['systolic', 'diastolic'].flatMap(section =>
                    Object.entries(parsedData[section] || {}).flatMap(([type, ranges]) => {
                        if (!Array.isArray(ranges)) return [];
                        return ranges.map(([min, max]) => ({ min, max, type, section: section.toUpperCase() }));
                    })
                );
    
                map[item.type] = { ...item, thresholds };
            } else {
                const thresholds = Object.entries(parsedData || {}).flatMap(([type, ranges]) => {
                    if (!Array.isArray(ranges)) return [];
                    return ranges.map(([min, max]) => ({ min, max, type }));
                });
                map[item.type] = { ...item, thresholds};
            }
        });
    
        return map;
    }, [currentPatientVitalsThresholds]);


    return (
        <div className="thresholds-view">
            <div className="thresholds-grid">
                <ThresholdCard
                    title="BLOOD GLUCOSE"
                    code="BloodGlucose"
                    unit="mg/dL"
                    data={thresholdsMap?.BloodGlucose || {}}
                />
                <ThresholdCard
                    title="HEART RATE"
                    code="HeartRate"
                    unit="bpm "
                    data={thresholdsMap?.HeartRate || {}}
                />
                <ThresholdCard
                    title="BLOOD PRESSURE"
                    code="BloodPressure"
                    unit="mmHg"
                    hasSections={true}
                    data={thresholdsMap?.BloodPressure || {}}
                />
                <ThresholdCard
                    title="RESPIRATION RATE"
                    code="RespirationRate"
                    unit="bprm"
                    data={thresholdsMap?.RespirationRate || {}}
                />
                <ThresholdCard
                    title="SPO2"
                    code="SPO2"
                    unit="Percentage"
                    data={thresholdsMap?.SPO2 || {}}
                />
            </div>
        </div>
    );
});

export default Threshold;
